import axios from 'axios'

const fractal = axios.create({
  baseURL: process.env.REACT_APP_FRACTAL,
  headers: {
    Authorization: `Bearer ${process.env.REACT_APP_FRACTAL_TOKEN}`,
    'Content-Type': 'application/json; charset=utf-8'
  },
})


export default fractal
